import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import CampanhaModel from "@/models/programafidelidade/campanhaModel";
import campanhaService from "@/services/campanhaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class CampanhaListComponent extends ListComponentBase<CampanhaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", "Descrição", GridColumnType.String),
            new GridColumn("dataInicio", "Data Inicio", GridColumnType.Date),
            new GridColumn("dataFim", "Data Fim", GridColumnType.Date),
            new GridColumn("padrao", "Padrao", GridColumnType.Boolean),
        ];
    }

    private beforeMount() {
        this.setPropsCached(campanhaService, "campanha", "descricao", true);
    }
}
